import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, User } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "../lib/auth";

const Login = () => {
  const { login } = useAuth();
  const nav = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!username || !password) return;
    setLoading(true);
    try {
      await login(username, password);
      toast.success("Giriş başarılı");
      nav("/admin");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Giriş başarısız");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="login-page" className="bg-zinc-950 text-white min-h-screen flex items-center justify-center pt-20 pb-10 px-6">
      <div className="w-full max-w-md">
        <div className="mb-8 text-center">
          <div className="flex items-center justify-center gap-3 mb-3">
            <span className="block h-px w-8 bg-orange-500" />
            <span className="text-orange-500 font-bold uppercase tracking-[0.3em] text-xs">Yönetim Girişi</span>
            <span className="block h-px w-8 bg-orange-500" />
          </div>
          <h1 className="font-display text-4xl md:text-5xl font-bold uppercase tracking-tight">
            Gensan <span className="text-orange-500">Admin</span>
          </h1>
        </div>
        <form onSubmit={submit} className="bg-black border border-zinc-900 p-8 space-y-5">
          <div>
            <label className="block text-xs uppercase tracking-widest text-zinc-500 mb-2">Kullanıcı Adı</label>
            <div className="relative">
              <User size={16} className="absolute left-4 top-1/2 -translate-y-1/2 text-zinc-500" />
              <input data-testid="login-username" value={username} onChange={e => setUsername(e.target.value)}
                className="w-full bg-transparent border border-zinc-800 focus:border-orange-500 outline-none pl-11 pr-4 py-3 text-white" />
            </div>
          </div>
          <div>
            <label className="block text-xs uppercase tracking-widest text-zinc-500 mb-2">Şifre</label>
            <div className="relative">
              <Lock size={16} className="absolute left-4 top-1/2 -translate-y-1/2 text-zinc-500" />
              <input data-testid="login-password" type="password" value={password} onChange={e => setPassword(e.target.value)}
                className="w-full bg-transparent border border-zinc-800 focus:border-orange-500 outline-none pl-11 pr-4 py-3 text-white" />
            </div>
          </div>
          <button type="submit" disabled={loading} data-testid="login-submit"
            className="w-full bg-orange-600 hover:bg-orange-700 disabled:opacity-50 text-white px-6 py-3 font-bold uppercase tracking-widest text-sm transition-colors">
            {loading ? "Giriş yapılıyor..." : "Giriş Yap"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
